"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var ToastGroup_1 = require("./ToastGroup");
var framer_motion_1 = require("framer-motion");
var internal_1 = require("../../internal");
var tokens_1 = __importDefault(require("@servicetitan/tokens"));
var Toast = /** @class */ (function (_super) {
    __extends(Toast, _super);
    function Toast(props) {
        var _this = _super.call(this, props) || this;
        _this.timeout = null;
        _this.handleClose = function (e) {
            var onClose = _this.props.onClose;
            _this.clearSubscription();
            _this.setState({ visible: false });
            if (onClose) {
                onClose(e);
            }
        };
        _this.state = {
            visible: true,
        };
        return _this;
    }
    Toast.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.duration === null || this.props.duration === 0)
            return;
        this.timeout = window.setTimeout(function () {
            _this.handleClose();
        }, this.props.duration);
    };
    Toast.prototype.componentWillUnmount = function () {
        this.clearSubscription();
    };
    Toast.prototype.hasPrimaryAction = function () {
        return !!(this.props.primaryActionName && this.props.onPrimaryActionClick);
    };
    Toast.prototype.hasSecondaryAction = function () {
        return !!(this.props.secondaryActionName && this.props.onSecondaryActionClick);
    };
    Toast.prototype.clearSubscription = function () {
        if (this.timeout !== null) {
            window.clearTimeout(this.timeout);
        }
    };
    Toast.prototype.getIconNameByStatus = function () {
        switch (this.props.status) {
            case 'critical':
                return 'warning';
            case 'warning':
                return 'warning';
            case 'success':
                return 'check_circle';
        }
        // if status == 'info' || undefined
        return 'info';
    };
    Toast.prototype.render = function () {
        var _a = this.props, primaryActionName = _a.primaryActionName, secondaryActionName = _a.secondaryActionName, children = _a.children, className = _a.className, onPrimaryActionClick = _a.onPrimaryActionClick, onSecondaryActionClick = _a.onSecondaryActionClick, onClose = _a.onClose, portal = _a.portal, status = _a.status, title = _a.title, props = __rest(_a, ["primaryActionName", "secondaryActionName", "children", "className", "onPrimaryActionClick", "onSecondaryActionClick", "onClose", "portal", "status", "title"]);
        var ToastClasses = classnames_1.default('Toast', className, {
            'Toast--critical': status === 'critical',
            'Toast--info': status === 'info',
            'Toast--success': status === 'success',
            'Toast--warning': status === 'warning',
            'Toast--floating': portal,
        });
        var durationSlow = parseInt(tokens_1.default.durationSlow, 10) / 1000; // '300ms' -> 0.3
        var toastAnimation = {
            initial: { opacity: 0, y: 10, scale: 0.3 },
            animate: { opacity: 1, y: 0, scale: 1 },
            exit: { opacity: 0, y: 20, scale: 0.5 },
            transition: { type: 'easeInOut', duration: durationSlow },
        };
        var toast = (react_1.default.createElement(framer_motion_1.AnimatePresence, null,
            react_1.default.createElement(framer_motion_1.motion.div, __assign({ layout: true }, toastAnimation),
                react_1.default.createElement("div", __assign({ className: ToastClasses }, props),
                    react_1.default.createElement(__1.Icon, { className: "Toast__icon", name: this.getIconNameByStatus() }),
                    react_1.default.createElement("div", { className: "Toast__text" },
                        react_1.default.createElement("div", { className: "Toast__header" },
                            react_1.default.createElement("div", { className: "Toast__title" }, title),
                            onClose && (react_1.default.createElement(__1.Button, { fill: "subtle", className: "Toast__close", iconName: "clear", size: "xsmall", onClick: this.handleClose }))),
                        this.props.children !== undefined && (react_1.default.createElement("div", { className: "Toast__description" }, this.props.children))),
                    (primaryActionName || secondaryActionName) && (react_1.default.createElement("div", { className: "Toast__action" },
                        this.hasSecondaryAction() && (react_1.default.createElement(__1.Button, { fill: "subtle", small: true, onClick: onSecondaryActionClick }, secondaryActionName)),
                        this.hasPrimaryAction() && (react_1.default.createElement(__1.Button, { fill: "outline", small: true, onClick: onPrimaryActionClick }, primaryActionName))))))));
        return (react_1.default.createElement(internal_1.Portal, { conditional: !!portal, target: typeof portal !== 'boolean' ? portal : undefined }, toast));
    };
    Toast.Group = ToastGroup_1.ToastGroup;
    Toast.defaultProps = {
        status: 'info',
        duration: 8000,
        portal: true,
    };
    return Toast;
}(react_1.Component));
exports.Toast = Toast;
//# sourceMappingURL=Toast.js.map